// KAN DENNA TAS BORT? INNEHÅLLER ALLT I WeekSchedulePage.JSX NU?
import React, { useMemo, useState } from "react";
import {
    Box,
    Button,
    Chip,
    Grid,
    MenuItem,
    TextField,
    Typography,
    useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import { tokens } from "../assets/theme";
import {
    useWeekTemplates,
    useMachines,
    useAssignTemplate,
} from "../hooks/useWeekSchedule";

function AssignWeekTemplateToMachinesPage() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const companyKey = 1; // byt till något dynamiskt om ni vill

    const [selectedTemplateId, setSelectedTemplateId] = useState("");
    const [selectedMachineIds, setSelectedMachineIds] = useState([]);
    const [weekStart, setWeekStart] = useState(
        dayjs().startOf("week").add(1, "day").format("YYYY-MM-DD") // måndag
    );
    const [validTo, setValidTo] = useState("");

    const { data: templates = [] } = useWeekTemplates(companyKey);
    const { data: machines = [] } = useMachines(companyKey);

    const assignTemplateMutation = useAssignTemplate();

    const weekEndDefault = useMemo(
        () => dayjs(weekStart).add(6, "day").format("YYYY-MM-DD"),
        [weekStart]
    );

    const workspaceBg =
        theme.palette.mode === "dark"
            ? colors.primary[700]
            : colors.grey[100];

    const dateTimeIconSx =
        theme.palette.mode === "dark"
            ? {
                  "& input::-webkit-calendar-picker-indicator": {
                      filter: "invert(1)",
                  },
              }
            : {};

    const handleAssign = async () => {
        if (!selectedTemplateId || selectedMachineIds.length === 0) return;

        const vf = dayjs(weekStart).startOf("day").toISOString();
        const vt = validTo ? dayjs(validTo).endOf("day").toISOString() : null;

        for (const machineId of selectedMachineIds) {
            await assignTemplateMutation.mutateAsync({
                machineId: machineId,
                weekTemplateId: Number(selectedTemplateId),
                validFrom: vf,
                validTo: vt,
            });
        }
    };

    return (
        <Box p={2} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Box
                sx={{
                    mt: 1.5,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: workspaceBg,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <Typography variant="h5" gutterBottom>
                    Koppla veckoschema till maskiner
                </Typography>

                <Grid container spacing={2} mb={1}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            type="date"
                            label="Vecka start (måndag)"
                            InputLabelProps={{ shrink: true }}
                            value={weekStart}
                            onChange={(e) => setWeekStart(e.target.value)}
                            sx={dateTimeIconSx}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            type="date"
                            label="Giltig t.o.m."
                            InputLabelProps={{ shrink: true }}
                            value={validTo || ""}
                            placeholder={weekEndDefault}
                            onChange={(e) => setValidTo(e.target.value)}
                            sx={dateTimeIconSx}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            select
                            fullWidth
                            label="Veckoschema"
                            value={selectedTemplateId}
                            onChange={(e) =>
                                setSelectedTemplateId(
                                    e.target.value === "" ? "" : Number(e.target.value)
                                )
                            }
                        >
                            <MenuItem value="">
                                <em>Välj schema</em>
                            </MenuItem>
                            {templates.map((t) => (
                                <MenuItem key={t.id} value={t.id}>
                                    {t.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            select
                            fullWidth
                            label="Maskiner"
                            SelectProps={{
                                multiple: true,
                                renderValue: (selected) => (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 0.5,
                                        }}
                                    >
                                        {selected.map((id) => {
                                            const m = machines.find((x) => x.id === id);
                                            return (
                                                <Chip
                                                    key={id}
                                                    label={m ? m.machineName : id}
                                                    size="small"
                                                />
                                            );
                                        })}
                                    </Box>
                                ),
                            }}
                            value={selectedMachineIds}
                            onChange={(e) =>
                                setSelectedMachineIds(
                                    typeof e.target.value === "string"
                                        ? e.target.value.split(",").map(Number)
                                        : e.target.value
                                )
                            }
                        >
                            {machines.map((m) => (
                                <MenuItem key={m.id} value={m.id}>
                                    {m.machineName}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>

                <Box mt={2}>
                    <Button
                        variant="contained"
                        onClick={handleAssign}
                        disabled={
                            !selectedTemplateId ||
                            selectedMachineIds.length === 0 ||
                            assignTemplateMutation.isPending
                        }
                    >
                        Koppla schema till maskiner
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default AssignWeekTemplateToMachinesPage;
